<template>
  <div class="backoffice">
    <h3>{{ labels.backoffice }}</h3>
    <br />

    <b-form-row class="b-form-row">
      <b-col sm="12" md="6" lg="6" xl="6">
        <b-form-group v-bind:label="labels.origine">
          <b-form-select
            class="b-form-select"
            id="origine"
            v-model="origine"
            :options="valori_origine"
            :size="size"
            :plain="$store.state.SelectPlain"
          ></b-form-select>
          <p class="errore" id="errore-origine" v-if="isError(errori.origine)">
            {{ labels_errori[errori.origine] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="6" xl="6">
        <b-form-group v-bind:label="labels.reservation_code">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="reservation-code"
            v-model="reservation_code"
            maxlength="45"
          ></b-form-input>
          <p
            class="errore"
            id="errore-reservation-code"
            v-if="isError(errori.reservation_code)"
          >
            {{ labels_errori[errori.reservation_code] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="b-form-row" style="text-align: center">
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-button
          variant="success"
          @click="modifica"
          :disabled="invio_in_corso"
          >{{ labels.modifica }}</b-button
        >
        <div
          class="errore"
          id="errore-modifica"
          v-if="isError(errori.modifica)"
        >
          <br />
          {{ labels_errori[errori.modifica] }}
        </div>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "BackOffice",
  data() {
    return {
      origine: this.$store.state.Struttura,
      reservation_code: "",
      labels: {},
      labels_errori: {},
      size: "sm",
      errori: {},
      invio_in_corso: false,

      valori_origine: [
        {
          value: this.$store.state.Struttura,
          text: this.$store.state.DescrizioneStruttura,
        },
        { value: "SIMPLEBOOKING", text: "simpleBooking" },
      ],
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  mixins: [utility],

  methods: {
    modifica() {
      try {
        let me = this;

        if (!fn_ControllaDati(this)) {
          return;
        }

        let ServerURL = this.$store.state.ServerURL;
        this.invio_in_corso = true;

        axios({
          method: "get",
          url:
            ServerURL +
            "?canale=BackOffice" +
            "&origine=" +
            me.origine.trim() +
            "&reservationcode=" +
            me.reservation_code.trim(),
          responseType: "text",
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              // La prenotazione esiste e possono chiamare la route /backoffice per gestirla
              me.$router.push(
                "/backoffice/" +
                  me.origine.trim() +
                  "?reservationcode=" +
                  me.reservation_code.trim()
              );
            } else if (response.data.errore == -2) {
              // La funzione che legge la prenotazione ha ritornato un errore bloccante
              me.registraErrore(response.data.esito, "BackOffice-modifica");
            } else {
              // La funzione che legge la prenotazione ha ritornato un errore utente (per esempio prenotazione non trovata).
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            fn_CambiaCursore("default", me);
            me.invio_in_corso = false;
            me.registraErrore(error, "BackOffice-modifica");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "BackOffice-modifica");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    try {
      // Controllo dei diritti di accesso spostato in Amministrazione.vue
      let UtenteAutenticato = store.state.UtenteAutenticato;
      if (to.meta.requiresAuth && !UtenteAutenticato) {
        router.push(
          "/amministrazione/permessiinsufficienti",
          null,
          function () {}
        );
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
    } catch (error) {
      this.registraErrore(error, "BackOffice-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      backoffice:
        "Backoffice - Funzione di modifica prenotazioni da backoffice",
      origine: "Origine prenotazione",
      reservation_code: "Numero prenotazione",
      modifica: "Modifica prenotazione",
    };
    let labels_inglese = {
      backoffice:
        "Backoffice - Funzione di modifica prenotazioni da backoffice",
      origine: "Origine prenotazione",
      reservation_code: "Numero prenotazione",
      modifica: "Modifica prenotazione",
    };
    let labels_tedesco = {
      backoffice:
        "Backoffice - Funzione di modifica prenotazioni da backoffice",
      origine: "Origine prenotazione",
      reservation_code: "Numero prenotazione",
      modifica: "Modifica prenotazione",
    };
    let labels_francese = {
      backoffice:
        "Backoffice - Funzione di modifica prenotazioni da backoffice",
      origine: "Origine prenotazione",
      reservation_code: "Numero prenotazione",
      modifica: "Modifica prenotazione",
    };

    let labels_errori_italiano = {
      dato_obbligatorio: "Dato obbligatorio",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      struttura_non_trovata: "Struttura non trovata",
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      dato_obbligatorio: "Dato obbligatorio",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      struttura_non_trovata: "Struttura non trovata",
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      dato_obbligatorio: "Dato obbligatorio",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      struttura_non_trovata: "Struttura non trovata",
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      dato_obbligatorio: "Dato obbligatorio",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      prenotazione_non_trovata: "Prenotazione non trovata",
      struttura_non_trovata: "Struttura non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "BackOffice-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};

    if (vm.origine.trim() == "") {
      vm.errori.origine = "dato_obbligatorio";
      esito = false;
    }
    if (vm.reservation_code.trim() == "") {
      vm.errori.reservation_code = "dato_obbligatorio";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.modifica = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "BackOffice-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>
<style scoped>
.backoffice {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
